import { createFileRoute } from "@tanstack/react-router";
import Services from "@/pages/Services";
import { SITE_URL, OG_IMAGE } from "@/lib/site-data";
import { breadcrumbLd, webPageLd } from "@/lib/seo";

const title = "Hardwood, Tile, Laminate & Marble Flooring | JTB Floors";
const description =
  "Expert installation of hardwood, ceramic, laminate, hard tile & marble flooring. Materials and labor included. 35 years of craftsmanship in Barrington, IL.";

export const Route = createFileRoute("/services")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/services` },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/services` }],
    scripts: [breadcrumbLd("Services", "/services"), webPageLd("WebPage", title, description, "/services")],
  }),
  component: Services,
});
